import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";

class ImageCollectionEditModalController {
    
    public isLoading = false;
    public collectionBackgroundColors;
    public imageSet;
	
	// @ngInject
	constructor(
		public imageService   : ImageService,
		public ModalService,
		private davisAlertService
	){}
	
	public $onInit = () => {
		
		for(var i=0; i<this.collectionBackgroundColors.options.length; i++){
			
			var option = this.collectionBackgroundColors.options[i];

			if(this.imageSet.backgroundColor === option.value){
				this.imageSet.backgroundColor = option; 
				break;
			}
		}
	}

	public save = () =>{
		
		this.isLoading = true;
		
		this.imageSet.backgroundColor = this.imageSet.backgroundColor.value;
		
		this.imageService.saveImageSet(this.imageSet).then(
			(response)=>{
				console.log('respy', response);
			},
			(reason) =>{

			}
		).finally(()=>{
			this.close();
		})
		
		
		
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}
}
    

class ImageCollectionEditModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		close:'=',
		collectionBackgroundColors: '=?',
		imageSet:'=?'
	};

	public controller = ImageCollectionEditModalController;
	public controllerAs = 'imageCollectionEditModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-edit-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionEditModal };
